module.exports = __webpack_public_path__ + "img/744.5489355e.jpg";